import { Box, Grid, RadioGroup, Tab, Tabs } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import React from 'react'
import clsx from 'clsx'
import { Controller } from 'react-hook-form'
import { BaseRadio } from '@Components/Form/BaseRadio/BaseRadio'
import { RedditTextField } from '@Components/Form/RedditTextField/RedditTextField'
import { FormService } from '@Services/form.service'
import VISA from '@Images/icons/VISA.png'
import Master from '@Images/icons/Master.png'
import PayPal from '@Images/icons/PAYPAL.png'
import { $Gray90, $WhiteSmoke } from '@Styles/colors'
import BoxContainer from '../../../components/Box/BoxContainer/BoxContainer'

// styles section
const useStyles = makeStyles({
    root: {
        padding: 0,
        // display: 'block',
        '& .MuiButtonBase-root.MuiTab-textColorPrimary': {
            // transition: '0.2s',
            border: `0.5px solid ${$Gray90}`,
            borderRadius: '10px',
            marginRight: 10,
            position: 'relative',
            width: 'calc(50% - 5px)',
            marginBottom: 5,
            maxWidth: 'unset',
            justifyContent: 'start',

            '& .MuiTab-wrapper': {
                width: 'unset',
            },
        },
        '& .Mui-selected.MuiTab-textColorPrimary': {
            background: $WhiteSmoke,
            border: `0.5px solid ${$WhiteSmoke}`,
            // transition: '0.2s',
            position: 'relative',
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            marginBottom: 0,
        },
    },
    box: {
        background: $WhiteSmoke,
        borderRadius: 10,
        '& .MuiBox-root': {
            padding: '35px 20px 10px 20px',
            minHeight: 230,
        },
    },
    form: {
        '& .MuiTextField-root, .MuiFormControl-root': {
            margin: '-15px 0',
        },
    },
    borderLeftRadiusNone: {
        borderTopLeftRadius: 0,
    },
    borderRightRadiusNone: {
        borderTopRightRadius: 0,
    },
})

// models section
interface TabPanelProps {
    children?: React.ReactNode
    index: any
    value: any
}

function TabPanel(props: TabPanelProps) {
    // core section
    const { children, value, index, ...other } = props

    // main
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </div>
    )
}

// models section
interface IPayments {
    control?: any
    errors?: any
    tabValue?: number
    setTabValue?: any
}

function Payments(props: IPayments) {
    // core section
    const { control, errors, tabValue, setTabValue } = props
    const classes = useStyles()
    const classesInput = 'reddit-input mb-2 w-100'
    const ac = new AbortController()

    // functions section
    const handleTabChange = (
        event: React.ChangeEvent<any>,
        newValue: number
    ) => {
        setTabValue(newValue)
    }

    // main
    return (
        <BoxContainer title="Payment Options" className="payment-options">
            <Tabs
                value={tabValue}
                indicatorColor="primary"
                textColor="primary"
                onChange={handleTabChange}
                aria-label="disabled tabs example"
                className={`${classes.root} payment-tabs w-100`}
                TabIndicatorProps={{
                    style: {
                        display: 'none',
                    },
                }}
            >
                <Tab
                    label={
                        <RadioGroup
                            aria-label="quiz"
                            name="quiz"
                            value={tabValue}
                            className="d-block"
                        >
                            <BaseRadio value={0} />
                            <img src={VISA} alt="visa" className="mr-2" />
                            <img src={Master} alt="master" />
                        </RadioGroup>
                    }
                />
                <Tab
                    label={
                        <RadioGroup
                            aria-label="quiz"
                            name="quiz"
                            value={tabValue}
                            className="d-block"
                        >
                            <BaseRadio value={1} />
                            <img src={PayPal} alt="paypal" />
                        </RadioGroup>
                    }
                />
            </Tabs>
            <Box
                className={clsx(
                    classes.box,
                    tabValue === 0
                        ? classes.borderLeftRadiusNone
                        : classes.borderRightRadiusNone
                )}
            >
                <TabPanel value={tabValue} index={0}>
                    <Grid container spacing={3} className={classes.form}>
                        <Grid item md={12}>
                            <Controller
                                control={control}
                                name="cardNumber"
                                defaultValue=""
                                rules={{ required: true }}
                                render={({
                                    field: { ref, value, onChange, ...field },
                                }: any) => (
                                    <RedditTextField
                                        {...field}
                                        value={value}
                                        onChange={onChange}
                                        inputRef={ref}
                                        label="Card Number"
                                        variant="filled"
                                        className={classesInput}
                                        error={errors?.cardNumber && true}
                                        helperText={FormService.getErrorMessage(
                                            errors,
                                            'cardNumber',
                                            'Card Number'
                                        )}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item md={12}>
                            <Controller
                                control={control}
                                name="nameOnCard"
                                defaultValue=""
                                rules={{ required: true }}
                                render={({
                                    field: { ref, value, onChange, ...field },
                                }: any) => (
                                    <RedditTextField
                                        {...field}
                                        value={value}
                                        onChange={onChange}
                                        inputRef={ref}
                                        label="Name On Card"
                                        variant="filled"
                                        className={classesInput}
                                        error={errors?.nameOnCard && true}
                                        helperText={FormService.getErrorMessage(
                                            errors,
                                            'nameOnCard',
                                            'Name On Card'
                                        )}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item md={8} sm={12}>
                            <Controller
                                control={control}
                                name="expiredDate"
                                defaultValue=""
                                rules={{ required: true }}
                                render={({
                                    field: { ref, value, onChange, ...field },
                                }: any) => (
                                    <RedditTextField
                                        {...field}
                                        value={value}
                                        onChange={onChange}
                                        inputRef={ref}
                                        label="Expiration Date"
                                        variant="filled"
                                        className={classesInput}
                                        error={errors?.expiredDate && true}
                                        helperText={FormService.getErrorMessage(
                                            errors,
                                            'expiredDate',
                                            'Expiration Date'
                                        )}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item md={4} sm={12}>
                            <Controller
                                control={control}
                                name="cvc"
                                defaultValue=""
                                rules={{ required: true }}
                                render={({
                                    field: { ref, value, onChange, ...field },
                                }: any) => (
                                    <RedditTextField
                                        {...field}
                                        value={value}
                                        onChange={onChange}
                                        inputRef={ref}
                                        label="CVC #"
                                        variant="filled"
                                        className={classesInput}
                                        error={errors?.cvc && true}
                                        helperText={FormService.getErrorMessage(
                                            errors,
                                            'cvc',
                                            'CVC #'
                                        )}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                </TabPanel>
                <TabPanel value={tabValue} index={1}>
                    <Grid container spacing={3} className={classes.form}>
                        <Grid item md={12}>
                            <Controller
                                control={control}
                                name="email"
                                defaultValue=""
                                rules={{ required: true }}
                                render={({
                                    field: { ref, value, onChange, ...field },
                                }: any) => (
                                    <RedditTextField
                                        {...field}
                                        value={value}
                                        onChange={onChange}
                                        inputRef={ref}
                                        label="Email Address"
                                        variant="filled"
                                        className={classesInput}
                                        error={errors?.email && true}
                                        helperText={FormService.getErrorMessage(
                                            errors,
                                            'email',
                                            'Email Address'
                                        )}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item md={12}>
                            <Controller
                                control={control}
                                name="password"
                                defaultValue=""
                                rules={{ required: true }}
                                render={({
                                    field: { ref, value, onChange, ...field },
                                }: any) => (
                                    <RedditTextField
                                        {...field}
                                        value={value}
                                        onChange={onChange}
                                        inputRef={ref}
                                        label="Password"
                                        variant="filled"
                                        className={classesInput}
                                        error={errors?.password && true}
                                        helperText={FormService.getErrorMessage(
                                            errors,
                                            'password',
                                            'Password'
                                        )}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                </TabPanel>
            </Box>
        </BoxContainer>
    )
}

export default Payments
